module.exports = __webpack_public_path__ + "static/media/multiple_pages_stamp.44d90318.svg";